import { type Resolution } from '../theme/resolution';
import { getResolutionMedia } from './getResolution';

export const matchResolutionMedia = (resolution: Resolution) => {
    return window.matchMedia(getResolutionMedia(resolution)).matches;
};
